"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getProductData_1 = require("./helpers/getProductData");
var CartModalAnalyze_1 = __importDefault(require("./CartModalAnalyze"));
/**
 * Klasa przypisująca się do zdarzeń elementów strony w celu wygenerowania zdarzeń GTMowych
 */
var GtmInteractions = /** @class */ (function () {
    function GtmInteractions(gtm, page) {
        var _this = this;
        this.gtm = gtm;
        this.page = page;
        if (document.readyState !== 'loading') {
            this.bindEvents();
        }
        else {
            document.addEventListener('DOMContentLoaded', function () {
                _this.bindEvents();
            });
        }
    }
    GtmInteractions.prototype.bindEvents = function () {
        var _this = this;
        // Kliknięcie w "Zaloguj"
        this.page.getLoginButtons().forEach(function (submit) {
            submit.addEventListener('click', function (e) { _this.onLogin(e); });
        });
        // Otwarcie menu z listą kolorów
        this.page.getColorChartOpenCloseButtons().forEach(function (overview) {
            overview.addEventListener('click', function () { _this.onColorChartStateChange(); });
        });
        // Wybór/odznaczenie filtra (wersja desktop)
        this.page.getFilterLabels().forEach(function (label) {
            label.addEventListener('click', function (e) { _this.onFilterLabelClick(e, label); });
        });
        // Odznaczenie filtra poprzez kliknięcie w obrębie sekcji "Wybrane filtry" (wersja desktop)
        this.page.getSelectedFiltersLabels().forEach(function (label) {
            label.addEventListener('click', function (e) { _this.onFilterLabelClick(e, label, false); });
        });
        // Zmiana sortowania listy produktowej
        this.page.getSortSelects().forEach(function (select) {
            select.addEventListener('change', function () {
                _this.onSortChange(select);
            });
        });
        // Kliknięcie w  "Składam zamówienie z obowiązkiem zapłaty"
        this.page.getCartConfirmButton().forEach(function (btn) {
            btn.addEventListener('click', function () { _this.onPaymentModeClick(); });
        });
        // Zmiana metody płatności
        this.page.getPaymentButton().forEach(function (btn) {
            btn.addEventListener('click', function () { _this.onPaymentModeClick(); });
        });
        // Kliknięcia w menu górnym
        this.page.getTopMenuAnchors().forEach(function (a) {
            a.addEventListener('click', function () { _this.onTopMenuClick(a); });
        });
        // Kliknięcie w "Zakup jednorazowy"
        this.page.getOnetimeRegisterButtons().forEach(function (btn) {
            btn.addEventListener('click', function () { _this.onRegisterAsOnetimeBtnClick(); });
        });
        // Kliknięcia w boksy produktowe
        this.page.getProductsListContainers().forEach(function (container) {
            _this.page.getProductContainers(container).forEach(function (productContainer) {
                productContainer.addEventListener('click', function (e) {
                    _this.onProductClick(e, productContainer, container);
                }, true);
            });
        });
        this.page.doc.addEventListener('product-modal-cart-add', (function (e) {
            var productInterface = e.detail.product;
            var sku = e.detail.sku;
            var color = e.detail.color;
            _this.onProductModalCartClick(productInterface, sku, color);
        }));
        // Dodanie produktu do koszyka z poziomu strony produktu
        this.page.getProductPageCartButtons().forEach(function (btn) {
            btn.addEventListener('click', function () { _this.onCartAddFromProductPage(); });
        });
        // Wyświetlenie produktów z cross-sellingu
        this.page.doc.addEventListener('cart-modal-crosses-load', function (e) {
            if (!(e.target instanceof Element)) {
                return;
            }
            var modal = new CartModalAnalyze_1.default(e.target);
            _this.onCartModalCrossesView(modal);
            // Kliknięcia w obrębie boksu produktowego
            _this.page.getProductContainers(modal.container).forEach(function (productContainer) {
                productContainer.addEventListener('click', function (clickEvent) {
                    _this.onProductClick(clickEvent, productContainer, modal.container);
                }, true);
            });
        }, true);
        // Zatwierdzenie formularza dodawania produktu do koszyka za pomocą SKU
        this.page.doc.addEventListener('product-added-by-sku', (function (e) {
            var productInterface = e.detail.product;
            var sku = e.detail.sku;
            _this.onAddToCartBySku(productInterface, sku);
        }));
        // Zatwierdzenie formularza subskrypcji newslettera (w nagłówku/stopce)
        this.page.getNewsletterForms().forEach(function (form) {
            form.addEventListener('submit', function () {
                _this.onNewsletterFormSubmit();
            });
        });
        // Zapisanie się do newslettera
        var subscriptionForm = this.page.getNewsletterSubscriptionForm();
        if (subscriptionForm !== null && subscriptionForm instanceof HTMLFormElement) {
            subscriptionForm.addEventListener('submit', function () {
                _this.onNewsletterSubscriptionSubmit(subscriptionForm);
            });
        }
        // Kliknięcie w "Zapomniałem hasło"
        this.page.getLostPasswordButtons().forEach(function (btn) {
            btn.addEventListener('click', function () { _this.onLostPasswordClick(); });
        });
        // Zatwierdzenie formularza resetowania hasła
        this.page.getLostPasswordSubmits().forEach(function (btn) {
            btn.addEventListener('click', function () { _this.onLostPasswordClick(); });
        });
        var exponeaProducts = document.querySelectorAll('.exponea-products');
        exponeaProducts.forEach(function (container) {
            container.addEventListener('product-click', (function (e) {
                if (!e.detail || !e.detail.product || !e.detail.cartAdd) {
                    return;
                }
                var productInterface = e.detail.product;
                var product = getProductData_1.getProductDataFromObject(productInterface, productInterface.sku, null);
                if (!product) {
                    return;
                }
                _this.onExponeaAddProductToCart(product);
            }));
        });
    };
    GtmInteractions.prototype.onExponeaAddProductToCart = function (product) {
        this.gtm.extendDataLayer({
            event: 'ecommerce',
            ecommerceAction: 'add',
            product: product,
            category: 'ecommerce',
            action: 'add',
            label: "P-" + (product ? product.productID : ''),
        });
    };
    /**
     * Metoda wykonywana z poziomu kodu głównej aplikacji, informująca moduł o wyświetleniu
     * formularza przypominania hasła
     * @param {Element} form
     */
    GtmInteractions.prototype.onLostPasswordFormShow = function (form) {
        var _this = this;
        if (!(form instanceof Element)) {
            return;
        }
        form.addEventListener('submit', function () {
            _this.onLostPasswordClick();
        });
    };
    GtmInteractions.prototype.onLostPasswordClick = function () {
        this.gtm.extendDataLayer({
            event: 'pageview',
            pagename: 'forgotten password popin',
            pagepath: '/forgotten-password-popin',
        });
    };
    GtmInteractions.prototype.onNewsletterSubscriptionSubmit = function (form) {
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'engagement',
            action: 'newsletterSubscriptionValidation',
            label: form.checkValidity() ? '1' : '0',
            value: '0',
            nonInteraction: '0',
        });
    };
    GtmInteractions.prototype.onNewsletterFormSubmit = function () {
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'engagement',
            action: 'newsletterSubscriptionClick',
            label: 'footer',
            value: '0',
            nonInteraction: '0',
        });
    };
    GtmInteractions.prototype.onAddToCartBySku = function (productInterface, sku) {
        var product = getProductData_1.getProductDataFromObject(productInterface, sku, null);
        this.gtm.extendDataLayer({
            event: 'ecommerce',
            ecommerceAction: 'add',
            product: product,
            category: 'ecommerce',
            action: 'add | byReference',
            label: "P-" + sku,
        });
    };
    GtmInteractions.prototype.onCartModalCrossesView = function (modal) {
        var productLists = this.page.getProductsLists(modal.container);
        var productID = modal.getCrossSellingSKUs().join(',');
        if (productLists.length >= 1) {
            this.gtm.extendDataLayer({
                event: 'pageview',
                ecommerceAction: 'view',
                product: productLists[0],
                pagename: productID + " add to cart popin",
                pagepath: "/" + productID + "-addtocart-popin",
            });
        }
    };
    GtmInteractions.prototype.onCartAddFromProductPage = function () {
        var container = this.page.getProductContainer();
        if (container === null) {
            return;
        }
        var product = getProductData_1.getProductData(container);
        var quantityInput = container.querySelector('#quantity');
        if (quantityInput && product) {
            var quantity = Number(quantityInput.value);
            if (quantity > 1) {
                product.quantity = quantity;
            }
        }
        this.gtm.extendDataLayer({
            event: 'ecommerce',
            ecommerceAction: 'add',
            product: product,
            category: 'ecommerce',
            action: 'add | detail',
            label: "P-" + (product ? product.productID : ''),
        });
    };
    GtmInteractions.prototype.onProductModalCartClick = function (productInterface, sku, color) {
        var product = getProductData_1.getProductDataFromObject(productInterface, sku, color);
        this.gtm.extendDataLayer({
            event: 'ecommerce',
            ecommerceAction: 'add',
            product: product,
            category: 'ecommerce',
            action: 'add | quickViewPopin',
            label: "P-" + (product ? product.productID : ''),
        });
    };
    GtmInteractions.prototype.onProductClick = function (e, container, list) {
        var listData = this.page.getProductListData(list);
        var product = getProductData_1.getProductData(container);
        var isCartModal = list.classList.contains('modal-cart');
        var action;
        var ecommerceAction = 'click';
        if (e.target instanceof Element && ((e.target.tagName === 'A'
            && (e.target.getAttribute('href') || '').indexOf('/cart/delfromcart') === 0)
            || (e.target.parentElement instanceof Element && e.target.parentElement.tagName === 'A'
                && (e.target.parentElement.getAttribute('href') || '').indexOf('/cart/delfromcart') === 0)
            || e.target.classList.contains('js-remove'))) {
            // Usunięcie produktu z koszyka
            action = 'remove';
            ecommerceAction = 'remove';
        }
        else if (e.target instanceof Element && e.target.tagName === 'CART-ADD') {
            // Kliknięcie w "Add to cart"
            var name_1 = listData.name;
            if (isCartModal) {
                name_1 = 'add to cart popin cross-selling';
            }
            else if (listData.template === 'special offers') {
                name_1 = 'gifts';
            }
            action = "add | " + name_1;
            ecommerceAction = 'add';
        }
        else if (e.target instanceof Element && e.target.parentElement instanceof Element &&
            ((e.target.parentElement.tagName === 'A'
                && (e.target.parentElement.getAttribute('href') || '').indexOf('#reviews') !== -1))) {
            // Kliknięcie w gwiazdki ze średnią ocen
            this.gtm.extendDataLayer({
                event: 'event',
                category: 'engagement',
                action: "review - view" + (isCartModal ? ' popin cross-selling' : ''),
                label: "" + (product ? product.productID : ''),
                value: '0',
                nonInteraction: '0',
            });
            return;
        }
        else {
            // Pozostałe przypadki kliknięcia w produkt
            action = "click | " + (isCartModal ? 'add to cart popin cross-selling' : listData.name);
        }
        this.gtm.extendDataLayer({
            event: 'ecommerce',
            ecommerceAction: ecommerceAction,
            product: product,
            productList: listData,
            category: 'ecommerce',
            action: action,
            label: "" + (product && !product.isGift ? 'P-' : '') + (product ? product.productID : ''),
        });
    };
    GtmInteractions.prototype.onRegisterAsOnetimeBtnClick = function () {
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'navigation',
            action: 'uniquePurchase',
            label: '',
            value: '0',
            nonInteraction: '0',
        });
    };
    GtmInteractions.prototype.onTopMenuClick = function (a) {
        var level = 'first level';
        var firstChild = null;
        if (a.children.length > 0) {
            firstChild = a.children.item(0);
        }
        if (firstChild !== null && firstChild.tagName === 'IMG') {
            // Link będący obrazkiem: dolna część menu
            level = 'bottom block';
        }
        else if (a.parentElement instanceof Element) {
            if (a.parentElement.tagName === 'LI'
                && a.parentElement.parentElement instanceof Element
                && a.parentElement.parentElement.parentElement instanceof Element
                && !a.parentElement.parentElement.parentElement.classList.contains('top-menu')) {
                // Link zagnieżdżony: side block (Nowości, Bestsellery) / third level
                var thirdParent = a.parentElement.parentElement.parentElement;
                if (thirdParent.classList.contains('col-btn')) {
                    level = 'side block';
                }
                else {
                    level = 'second level';
                }
            }
        }
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'navigation',
            action: level,
            label: (a.textContent || '').trim(),
            value: '0',
            nonInteraction: '0',
        });
    };
    GtmInteractions.prototype.onPaymentModeClick = function () {
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'navigation',
            action: 'paymentMode',
            label: this.gtm.serverParams ? this.gtm.serverParams.paymentMode : '',
            value: '0',
            nonInteraction: '0',
        });
    };
    GtmInteractions.prototype.onSortChange = function (select) {
        var selectedText = select.options[select.selectedIndex].text;
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'navigation',
            action: 'sorting',
            label: (selectedText || '').trim(),
            value: '0',
            nonInteraction: '0',
        });
    };
    GtmInteractions.prototype.onFilterLabelClick = function (e, label, filterSelectState) {
        if (!(e.target instanceof Element)) {
            return;
        }
        // Stan wyboru filtra
        var selected;
        if (typeof filterSelectState === 'undefined') {
            var checkbox = label.querySelector('input[type=checkbox]');
            if (checkbox !== null && checkbox instanceof HTMLInputElement) {
                selected = checkbox.checked;
            }
            // W przypadku kliknięcia na link nie zmienia się status zaznaczenia, stąd
            // odwracamy flagę
            if (e.target.tagName === 'SPAN') {
                selected = !selected;
            }
        }
        else {
            selected = filterSelectState;
        }
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'navigation',
            action: selected ? 'filterApply' : 'filterDisabled',
            label: label.getAttribute('data-url-name'),
            value: '0',
            nonInteraction: '0',
        });
    };
    GtmInteractions.prototype.onColorChartStateChange = function () {
        // Pobieramy ID produktu z aktualnej strony
        var productContainer = this.page.getProductContainer();
        if (productContainer === null) {
            return;
        }
        var product = getProductData_1.getProductData(productContainer);
        if (product === null) {
            return;
        }
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'navigation',
            action: 'openColorChart',
            label: product.productID,
            value: '0',
            nonInteraction: '0',
        });
    };
    GtmInteractions.prototype.onLogin = function (e) {
        if (e.target instanceof Element && e.target.classList.contains('disabled')) {
            return;
        }
        var location = 'from header';
        if (this.page.isAuthPage()) {
            location = 'from auth page';
        }
        this.gtm.extendDataLayer({
            event: 'event',
            category: 'login',
            action: location,
            label: '',
            value: '0',
            nonInteraction: '0',
        });
    };
    return GtmInteractions;
}());
exports.default = GtmInteractions;
